var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "add-work-email" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._m(0),
          _c("div", { staticClass: "text" }, [_vm._v("基本信息")]),
          _c(
            "div",
            { staticClass: "forms" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: {
                    inline: true,
                    model: _vm.form,
                    rules: _vm.rules,
                    size: "small",
                    "label-width": "96px",
                    autocomplete: "off",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标题:", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          maxlength: "50",
                          clearable: "",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "add-category",
                      attrs: { label: "选择分类:", prop: "category" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "category-container" },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-right": "16px",
                              },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.form.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "category", $$v)
                                },
                                expression: "form.category",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.categoryName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "add-category-btn",
                              staticStyle: { cursor: "pointer" },
                              on: { click: _vm.showAddCategoryDialog },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "10px",
                                  height: "10px",
                                  "margin-right": "4px",
                                },
                                attrs: {
                                  src: require("@/assets/img/announcement/add.png"),
                                },
                              }),
                              _c("span", [_vm._v("新建分类")]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "t-label", attrs: { label: "作者:" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          clearable: "",
                          maxlength: "256",
                          rows: "3",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.author,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "author", $$v)
                          },
                          expression: "form.author",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "接收人员:", prop: "receivers" } },
                    [
                      _c(
                        "div",
                        { staticClass: "category-container" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "select-u",
                              staticStyle: {
                                "margin-right": "16px",
                                width: "100%",
                              },
                              attrs: {
                                placeholder: "请选择接收人员",
                                "collapse-tags": "",
                                size: "medium",
                                multiple: "",
                                "popper-class": "hidden",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openUserPicker.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.form.receivers,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "receivers", $$v)
                                },
                                expression: "form.receivers",
                              },
                            },
                            _vm._l(_vm.form.receivers, function (user, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: user.name, value: user },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "flex" },
                      attrs: { label: "正文:", prop: "content" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticStyle: { width: "88px" } }, [
                                _vm._v("正文:"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            border: "1px solid #ccc",
                            width: "104vh",
                            position: "relative",
                          },
                        },
                        [
                          _c("Toolbar", {
                            staticStyle: { "border-bottom": "1px solid #ccc" },
                            attrs: {
                              editor: _vm.editor,
                              defaultConfig: _vm.toolbarConfig,
                              mode: _vm.mode,
                            },
                          }),
                          _c("Editor", {
                            staticStyle: {
                              height: "500px",
                              "overflow-y": "hidden",
                            },
                            attrs: {
                              defaultConfig: _vm.editorConfig,
                              mode: _vm.mode,
                            },
                            on: {
                              onCreated: _vm.onCreated,
                              onChange: _vm.onEditorChange,
                            },
                            model: {
                              value: _vm.html,
                              callback: function ($$v) {
                                _vm.html = $$v
                              },
                              expression: "html",
                            },
                          }),
                          _c("div", { staticClass: "word-count" }, [
                            _vm._v(_vm._s(_vm.wordCount) + "/10000"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { display: "flex" },
                      attrs: { label: "附件:", prop: "attachmentList" },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("attachment-upload", {
                            model: {
                              value: _vm.form.attachmentList,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "attachmentList", $$v)
                              },
                              expression: "form.attachmentList",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              _c(
                "el-button",
                { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
                [_vm._v("返回")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.reset },
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.preview },
                },
                [_vm._v("预览")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnSave },
                  on: { click: _vm.save },
                },
                [_vm._v("保存草稿")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnSubmit },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "add-category-dialog",
              attrs: {
                visible: _vm.addCategoryDialogVisible,
                width: "520px",
                modal: true,
                "append-to-body": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addCategoryDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "newCategoryForm",
                  attrs: { model: _vm.newCategoryForm },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "分类名", prop: "name" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "dialog-title",
                                  staticStyle: { "text-align": "left" },
                                },
                                [
                                  _vm._v("分类名 "),
                                  _c("br"),
                                  _c("span", [
                                    _vm._v(
                                      "新建分类默认排在最后，可在分类列表中调整显示排序"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入名称(限10个字符)",
                          maxlength: "10",
                        },
                        model: {
                          value: _vm.newCategoryForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.newCategoryForm, "name", $$v)
                          },
                          expression: "newCategoryForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.addCategoryDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addCategory },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "preview-dialog",
              attrs: {
                "append-to-body": true,
                visible: _vm.previewDialogVisible,
                width: "800px",
                title: "公告预览",
                modal: true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.previewDialogVisible = $event
                },
              },
            },
            [
              _c("div", { staticClass: "preview-content" }, [
                _c("div", { staticClass: "preview-title" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.previewData.title || "无标题")),
                  ]),
                ]),
                _c("div", { staticClass: "preview-meta" }, [
                  _vm.previewData.categoryName || _vm.previewData.author
                    ? _c("div", { staticClass: "meta-item" }, [
                        _c("span", { staticClass: "meta-value" }, [
                          _vm._v(_vm._s(_vm.previewData.author || "")),
                        ]),
                        _c("span", { staticStyle: { padding: "0 10px" } }, [
                          _vm._v("|"),
                        ]),
                        _c("span", { staticStyle: { color: "#409EFF" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                "#" + (_vm.previewData.categoryName || "") + "#"
                              ) +
                              " "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "meta-item" }, [
                    _c("span", [_vm._v(_vm._s(_vm.currentTime))]),
                  ]),
                ]),
                _c("div", { staticClass: "preview-body" }, [
                  _c("div", {
                    staticClass: "preview-html",
                    domProps: { innerHTML: _vm._s(_vm.previewData.content) },
                  }),
                ]),
                _vm.previewData.attachments &&
                _vm.previewData.attachments.length
                  ? _c("div", { staticClass: "preview-attachments" }, [
                      _c("h3", [_vm._v("附件")]),
                      _c(
                        "ul",
                        { staticClass: "attachment-list" },
                        _vm._l(
                          _vm.previewData.attachments,
                          function (file, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "attachment-item" },
                              [
                                _c("img", {
                                  staticClass: "el-icon-document",
                                  attrs: {
                                    src: require("@/assets/img/announcement/fujian.png"),
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "file-info" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "file-name",
                                      attrs: { title: file.name },
                                    },
                                    [_vm._v(_vm._s(file.name))]
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.previewDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "接收人员", multiple: true },
        on: { ok: _vm.selectedUser },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("新增公告内容")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }